
const  ServiceResponseTime= {
    WaterBranchAssignment : "12",
    WasteWaterBranchAssignment : "12",
    ReplyToInquiry : "7",
    ChangeAccountType : "6",
    ChangeSpecifications : "6",
    ChangeUnit : "7",
    ChangeCapacityContractualBranching : "7",
    ChangeBranchDiameter : "12",
    MeterSeparation : "12",
    MoveMeasuringDevices : "12",
    MeterTest : "10",
    MeterChange : "7",
    InstallAdditionalSiphon : "12",
    TemporaryDisconnectAndConnectBranch : "12",
    CollectOrMergeBranch : "12",
    MidTermBill : "آنی",
    BillingReview : "5",
    DeclareMeterConsumption : "آنی",
    SeeHistory : "آنی",
    BillingPayment : "آنی",
    Suggestions : "",
    SaleTankerWater : "2",

}

export default ServiceResponseTime